import React, { useEffect, useState } from "react";
import {  Container, StyledSelect } from "./styles";
import { Label } from "../CustomTextArea/styles";
import Spinner from "../Spinner";

export interface SelectProps {
  name?: string;
  placeholder: string;
  itemList: any;
  value?:string | number;
  valueObjectField:string;
  displayObjectField:string;
  disabled?:boolean,
  showSearch?:boolean,
  onChange: any;
  onPressEnter?: any;
  style?:any
}

type optionType = {
  value: string | number;
  label: string | number;
};

const CustomSelectAntDesign = ({ name,placeholder, onChange,onPressEnter,itemList,value,valueObjectField,displayObjectField,disabled,showSearch,style }: SelectProps) => {
  
  const [options,setOptions] = useState<any>([]);
  const [latestValue,setLatestValue] = useState("");


  useEffect(()=>{

    if (options.length === 0 && itemList != undefined) fillOptions();

  },[])

  const fillOptions = () => {

      var myList = new Array(); 

      itemList.forEach((element:any) => {
        myList.push({value:element[valueObjectField],label:element[displayObjectField]})
      });

      setOptions(myList);
      return myList;
  }

  const localOnChange = (value: any,option:any) => {
    console.log(`selected ${value}`);
    setLatestValue("");

    if (value === undefined) return;
    if (value === null) return;
    if (value === "") return;

    onChange(value);

  };
  
  const localOnSearch = (value: string) => {
    //console.log('search:', value);
    setLatestValue(value);
  };

  const localonInputKeyDown = (e: any) => {
    
    if (e.keyCode=== 13 && onPressEnter != undefined){
      onPressEnter(latestValue)
    }

  };

  
  


  return (
    <Container>

      {itemList && (
        <StyledSelect 
        
          size="large"
          placeholder={placeholder} 
          value={value} 
          onChange={localOnChange}
          onSearch={localOnSearch}  
          onInputKeyDown = {localonInputKeyDown}
          disabled={disabled} 
          showSearch ={showSearch}
          style={style}
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
          }
          options = {options || fillOptions}
          >

        </StyledSelect>
      )}


      {(itemList === undefined || itemList === null) && (
              <Spinner message=" " size="small"/>
      )}

    </Container>
  )
};

export default CustomSelectAntDesign;
